import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../utils/auth/useAuth";
import { Outlet } from "react-router-dom";


function NewsLanding() {
	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
	

	if(authState?.isAuthenticated){
		return(
			
                <>
                    <Outlet/>
                </>
		)
	}
}

export default NewsLanding;